module.exports = "/images/lena-av.png?e085be8eddf2c25654d6bcbd91eceeb5";